<template>
  <section class="page account-manage">
    <card-box title="账号资料" class="account-info-box" showGap>
      <cell-row labelFixTop label="头像">
        <div>
          <userAvatar :user="userInfo" :file="{ fullUrl: userInfo.avatar }" />
        </div>
      </cell-row>
      <cell-row label="账号">
        {{ userInfo.frontUserName || " - " }}
        <div v-show="!!userInfo.frontUserName" slot="action">
          <el-button type="text" @click="openWriteOffModal">注销</el-button>
        </div>
      </cell-row>
      <cell-row label="密码" :showValue="false">
        <div slot="action">
          <el-button type="text" @click="openPwdStep1Modal">修改</el-button>
        </div>
      </cell-row>
      <cell-row label="手机号">
        {{ userInfo.phoneNumber | tuomin }}
        <div v-show="!!userInfo.phoneNumber" slot="action">
          <el-button type="text" @click="changePhoneNum">修改</el-button>
        </div>
      </cell-row>
      <cell-row label="昵称">
        {{ userInfo.truename || name || " - " }}
        <div slot="action">
          <el-button type="text" @click="changeUserName">修改</el-button>
        </div>
      </cell-row>
      <!-- <cell-row label="微信">
        {{ userInfo.wxCode || '暂未绑定' }}
        <div slot="action">
          <el-button type="text" @click="handleBindWx">{{ userInfo.wxCode ? '解绑' : '绑定' }}</el-button>
        </div>
      </cell-row> -->
      <cell-row label="邮箱">
        {{ userInfo.email || "暂未绑定" }}
        <div slot="action">
          <el-button type="text" @click="changeEmail">{{
            userInfo.email ? "修改" : "绑定"
          }}</el-button>
        </div>
      </cell-row>
    </card-box>
    <card-box title="所在机构" class="unit-table-box">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="deptName" label="机构名称" width="240">
        </el-table-column>
        <el-table-column prop="subject" label="专业名称"> </el-table-column>
        <el-table-column prop="joinDate" label="加入日期" width="230">
        </el-table-column>
      </el-table>
    </card-box>

    <!-- 注销账号模态框 start -->
    <el-dialog
      title="注销账号"
      :visible.sync="writeOffShow"
      width="400px"
      append-to-body
      center
      :close-on-click-modal="false"
      :before-close="beforeWriteOffClose"
      :destroy-on-close="true"
      class="ou-modal"
    >
      <div class="form-wrap">
        <div v-show="writeOffStep === 1" class="write-off-tip">
          <p>注销后，你将无法使用当前账号</p>
          <p>相关数据也将被删除无法找回</p>
        </div>
        <div v-show="writeOffStep === 2">
          <div class="tip-row">请验证你的身份，验证通过将注销账号</div>
          <div class="tip-row">验证码将发送到 {{ writeOffForm.phoneText }}</div>
          <el-form
            ref="writeOffForm"
            :rules="writeOffRules"
            :model="writeOffForm"
            hide-required-asterisk
          >
            <el-form-item class="form-item hidden-item" prop="phoneNum">
              <el-input
                v-model.trim="writeOffForm.phoneNum"
                type="text"
                placeholder="请输入手机号"
              />
            </el-form-item>
            <el-form-item prop="verifyCode" class="form-item vcode-item">
              <div class="ou-expand">
                <el-input
                  v-model.trim="writeOffForm.verifyCode"
                  type="text"
                  placeholder="请输入验证码"
                />
              </div>
              <el-button
                class="vcode-btn"
                :class="[vCodeBtnDisabled_writeOff ? 'biger' : '']"
                @click="openBioReg"
                :disabled="vCodeBtnDisabled_writeOff"
                >{{ vCodeBtnTextWriteOff }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="ou-btn-mono" @click="writeOffShow = false"
          >取 消</el-button
        >
        <!-- <el-button class="ou-btn-block" @click="cancelWriteOff">取消</el-button> -->
        <el-button
          :loading="writeOffLoading"
          type="primary"
          class="ou-btn-mono"
          v-show="writeOffStep === 1"
          @click.native.prevent="writeOffStep = 2"
        >
          <span>确认注销</span>
        </el-button>
        <el-button
          :loading="writeOffLoading"
          type="primary"
          class="ou-btn-mono"
          v-show="writeOffStep === 2"
          @click.native.prevent="handleWriteOff"
        >
          <span>确认注销</span>
        </el-button>
      </div>
    </el-dialog>
    <!-- 注销账号模态框 end -->

    <!-- 修改手机号模态框 start -->
    <el-dialog
      :title="stepModalTitle"
      :visible.sync="stepShow"
      width="400px"
      append-to-body
      center
      :close-on-click-modal="false"
      :before-close="beforeStepClose"
      :destroy-on-close="true"
      class="ou-modal"
    >
      <div class="form-wrap">
        <el-form
          v-show="editPhoneStep === 1"
          ref="step1Form"
          :rules="verifyCodeRules"
          :model="step1Form"
          hide-required-asterisk
        >
          <el-form-item class="form-item hidden-item" prop="phoneNum">
            <el-input
              v-model.trim="step1Form.phoneNum"
              type="text"
              placeholder="请输入手机号"
            />
          </el-form-item>
          <el-form-item class="form-item" prop="phoneText">
            <el-input
              v-model.trim="step1Form.phoneText"
              :disabled="!!userInfo.phoneNumber"
              type="text"
              placeholder="请输入手机号"
            />
          </el-form-item>
          <el-form-item prop="verifyCode" class="form-item vcode-item">
            <div class="ou-expand">
              <el-input
                v-model.trim="step1Form.verifyCode"
                type="text"
                placeholder="请输入验证码"
              />
            </div>
            <el-button
              class="vcode-btn"
              :class="[vCodeBtnDisabled ? 'biger' : '']"
              @click="openBioReg"
              :disabled="vCodeBtnDisabled"
              >{{ vCodeBtnText }}
            </el-button>
          </el-form-item>
        </el-form>
        <el-form
          v-show="editPhoneStep === 2"
          ref="phoneStep2Form"
          :rules="verifyCodeRules"
          :model="phoneStep2Form"
          hide-required-asterisk
        >
          <el-form-item class="form-item" prop="phoneNum">
            <el-input
              v-model.trim="phoneStep2Form.phoneNum"
              type="text"
              placeholder="请输入新手机号"
            />
          </el-form-item>
          <el-form-item prop="verifyCode" class="form-item vcode-item">
            <div class="ou-expand">
              <el-input
                v-model.trim="phoneStep2Form.verifyCode"
                type="text"
                placeholder="请输入验证码"
              />
            </div>
            <el-button
              class="vcode-btn"
              :class="[vCodeBtnDisabled2 ? 'biger' : '']"
              @click="openBioRegStep2"
              :disabled="vCodeBtnDisabled2"
              >{{ vCodeBtnText2 }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-show="editPhoneStep === 1"
          class="ou-btn-block"
          type="primary"
          @click="goNextStep"
          >下一步</el-button
        >
        <el-button
          :loading="submitPhoneLoading"
          type="primary"
          class="ou-btn-block"
          v-show="editPhoneStep === 2"
          @click.native.prevent="handleSetNewPhone"
        >
          <span v-if="!submitPhoneLoading">确定</span>
          <span v-else>请 稍 候...</span>
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改手机号模态框 end -->

    <!-- 修改密码模态框 start -->
    <el-dialog
      title="修改密码"
      :visible.sync="editPwdShow"
      width="400px"
      append-to-body
      center
      :close-on-click-modal="false"
      :before-close="beforeEditPwdClose"
      :destroy-on-close="true"
      class="ou-modal"
    >
      <div class="form-wrap">
        <el-form
          ref="editPwdForm"
          :rules="editPwdRules"
          :model="editPwdForm"
          hide-required-asterisk
        >
          <el-form-item class="form-item hidden-item" prop="phoneNum">
            <el-input
              v-model.trim="editPwdForm.phoneNum"
              type="text"
              placeholder="请输入手机号"
            />
          </el-form-item>
          <el-form-item class="form-item" prop="phoneText">
            <el-input
              v-model.trim="editPwdForm.phoneText"
              :disabled="!!userInfo.phoneNumber"
              type="text"
              placeholder="请输入手机号"
            />
          </el-form-item>
          <el-form-item prop="verifyCode" class="form-item vcode-item">
            <div class="ou-expand">
              <el-input
                v-model.trim="editPwdForm.verifyCode"
                type="text"
                placeholder="请输入验证码"
                readonly
                onfocus="this.removeAttribute('readonly');"
              />
            </div>
            <el-button
              class="vcode-btn"
              :class="[vCodeBtnDisabled_pwd ? 'biger' : '']"
              @click="openBioReg"
              :disabled="vCodeBtnDisabled_pwd"
              >{{ vCodeBtnTextPwd }}
            </el-button>
          </el-form-item>
          <el-form-item class="form-item" prop="password">
            <el-input
              v-model="editPwdForm.password"
              auto-complete="off"
              placeholder="请输入新密码"
              show-password
            />
          </el-form-item>
          <el-form-item class="form-item" prop="confirmPassword">
            <el-input
              v-model="editPwdForm.confirmPassword"
              show-password
              placeholder="请再次输入新密码"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          :loading="submitPwdLoading"
          type="primary"
          class="ou-btn-block"
          @click.native.prevent="handleSetNewPwd"
        >
          <span v-if="!submitPwdLoading">确定</span>
          <span v-else>请 稍 候...</span>
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改密码模态框 end -->

    <!-- 修改昵称模态框 start -->
    <el-dialog
      title="修改昵称"
      :visible.sync="truenameShow"
      width="400px"
      append-to-body
      center
      :close-on-click-modal="false"
      :before-close="beforeTruenameClose"
      :destroy-on-close="true"
      class="ou-modal"
    >
      <div class="form-wrap">
        <el-form
          ref="truenameForm"
          :rules="truenameRules"
          :model="truenameForm"
          hide-required-asterisk
        >
          <el-form-item class="form-item" prop="truename">
            <el-input
              v-model="truenameForm.truename"
              @change="nicknameChange"
              :maxlength="9"
              auto-complete="off"
              placeholder="请输入新昵称"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          :loading="submitTrueNameLoading"
          type="primary"
          class="ou-btn-block"
          @click.native.prevent="handleSetTruename"
        >
          <span v-if="!submitTrueNameLoading">确定</span>
          <span v-else>请 稍 候...</span>
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="emailModalTitle"
      :visible.sync="emailModalShow"
      width="400px"
      append-to-body
      center
      :close-on-click-modal="false"
      :before-close="beforeEmailClose"
      :destroy-on-close="true"
      class="ou-modal"
    >
      <div class="form-wrap">
        <el-form
          v-show="emailModalStep === 1"
          ref="emailForm"
          :rules="emailRules"
          :model="emailForm"
          hide-required-asterisk
        >
          <el-form-item class="form-item" prop="email">
            <el-input
              v-model.trim="emailForm.email"
              :disabled="!!userInfo.email"
              type="text"
              placeholder="请输入邮箱地址"
            />
          </el-form-item>
          <el-form-item prop="code" class="form-item vcode-item">
            <div class="ou-expand">
              <el-input
                v-model.trim="emailForm.code"
                type="text"
                placeholder="请输入验证码"
              />
            </div>
            <el-button
              class="vcode-btn"
              :class="[vCodeBtnDisabledEmail1 ? 'biger' : '']"
              @click="openBioRegEmail1"
              :disabled="vCodeBtnDisabledEmail1"
              >{{ vCodeBtnTextEmail1 }}
            </el-button>
          </el-form-item>
        </el-form>
        <el-form
          v-show="emailModalStep === 2"
          ref="emailForm2"
          :rules="emailRules"
          :model="emailForm2"
          hide-required-asterisk
        >
          <el-form-item class="form-item" prop="email">
            <el-input
              v-model.trim="emailForm2.email"
              type="text"
              placeholder="请输入邮箱地址"
            />
          </el-form-item>
          <el-form-item prop="code" class="form-item vcode-item">
            <div class="ou-expand">
              <el-input
                v-model.trim="emailForm2.code"
                type="text"
                placeholder="请输入验证码"
              />
            </div>
            <el-button
              class="vcode-btn"
              :class="[vCodeBtnDisabledEmail2 ? 'biger' : '']"
              @click="openBioRegEmail2"
              :disabled="vCodeBtnDisabledEmail2"
              >{{ vCodeBtnTextEmail2 }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          :loading="submitEmailLoading"
          type="primary"
          class="ou-btn-block"
          v-show="this.currentEmailStep === 1 && userInfo.email"
          @click.native.prevent="goEmailNext"
        >
          <span v-if="!submitEmailLoading">下一步</span>
          <span v-else>请 稍 候...</span>
        </el-button>
        <el-button
          :loading="submitEmailLoading"
          type="primary"
          class="ou-btn-block"
          v-show="
            (this.currentEmailStep === 1 && !userInfo.email) ||
            this.currentEmailStep === 2
          "
          @click.native.prevent="handleSetEmail"
        >
          <span v-if="!submitTrueNameLoading">确定</span>
          <span v-else>请 稍 候...</span>
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改昵称模态框 end -->
    <verify
      ref="bioReg"
      :mode="'pop'"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '330px', height: '155px' }"
      @success="bioRegPass"
    />
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { v4 as uuidv4 } from "uuid";
import {
  apiGetUserUnit,
  apiUpdateTrueName,
  apiUpdatePhone,
  apiVerifyEmail,
  apiUpdateEmail,
  apiCheckVerifyCode,
  apiCalcleUser,
} from "@/api/user/profile";
import UserAvatar from "./components/UserAvatar";
import CardBox from "./components/CardBox";
import CellRow from "./components/CellRow";
import Verify from "@/components/verifition/Verify";
import { encrypt } from "@/utils/jsencrypt";
import { setToken } from "@/utils/auth";
import {
  apiSendMsgCode,
  apiGetAuthConfig,
  apiUpdatePwd,
  apiLogin,
} from "@/api/user/login";

const mobile_reg =
  /^1(3[0-9]|4[01456879]|5[0-3,5-9]|6[2567]|7[0-8]|8[0-9]|9[0-3,5-9])\d{8}$/;
const email_reg =
  /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
export default {
  name: "accountManage",
  components: { UserAvatar, CardBox, CellRow, Verify },
  data() {
    return {
      tableData: [],
      userInfo: {},
      userInfoFetchDone: false,
      currentModal: "",
      stepShow: false,
      truenameShow: false,
      emailModalShow: false,
      editPwdShow: false,
      editPhoneStep: 1,
      currentEmailStep: 1,
      verifyKey: "",
      verifyKey2: "",
      vCodeBtnDisabled: false,
      vCodeBtnDisabled2: false,
      canResendSeconds1: 0,
      canResendSeconds2: 0,
      vCodeBtnDisabledEmail1: false,
      canResendEmailSeconds1: 0,
      vCodeBtnDisabledEmail2: false,
      canResendEmailSeconds2: 0,
      vCodeBtnDisabled_pwd: false,
      canResendSeconds_pwd: 0,
      verifyCodeRules: {
        phoneNum: [
          { required: true, trigger: "blur", message: "请输入手机号" },
          {
            pattern: mobile_reg,
            trigger: "blur",
            message: "请输入正确的手机号码",
          },
        ],
        verifyCode: [
          { required: true, trigger: "blur", message: "请输入验证码" },
        ],
      },
      pwdRules: {
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          { min: 8, max: 20, validator: this.validPassword, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, trigger: "blur", message: "请再次输入您的密码" },
          { required: true, validator: this.equalToPassword, trigger: "blur" },
        ],
      },
      editPwdRules: {
        phoneNum: [
          { required: true, trigger: "blur", message: "请输入手机号" },
          {
            pattern: mobile_reg,
            trigger: "blur",
            message: "请输入正确的手机号码",
          },
        ],
        verifyCode: [
          { required: true, trigger: "blur", message: "请输入验证码" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          { min: 8, max: 20, validator: this.validPassword, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, trigger: "blur", message: "请再次输入您的密码" },
          { required: true, validator: this.equalToPassword, trigger: "blur" },
        ],
      },
      truenameRules: {
        truename: [
          {
            required: true,
            whitespace: true,
            trigger: ["blur", "change"],
            message: "新昵称不能为空",
          },
          { max: 8, trigger: ["blur", "change"], message: "昵称最多可输入8位" },
        ],
      },
      emailRules: {
        email: [
          { required: true, trigger: "blur", message: "请输入邮箱" },
          {
            pattern: email_reg,
            trigger: "blur",
            message: "请输入正确的邮箱地址",
          },
        ],
        code: [{ required: true, trigger: "blur", message: "请输入验证码" }],
      },
      step1Form: {
        phoneNum: "",
        phoneText: "",
        verifyCode: "",
      },
      editPwdForm: {
        phoneNum: "",
        phoneText: "",
        verifyCode: "",
        verifyKey: "",
        password: "",
        confirmPassword: "",
      },
      phoneStep2Form: {
        phoneNum: "",
        verifyCode: "",
      },
      truenameForm: {
        truename: "",
      },
      emailForm: {
        email: "",
        code: "",
        uuid: "",
      },
      emailForm2: {
        email: "",
        code: "",
        uuid: "",
      },
      submitPwdLoading: false,
      submitPhoneLoading: false,
      submitTrueNameLoading: false,
      submitEmailLoading: false,
      isPwdEncrypt: "default",
      isValidateBlock: "default",

      /* 2022-08-10追加：以dialog的方式分布操作，验证手机后注销 */
      writeOffShow: false,
      writeOffStep: 1,
      vCodeBtnDisabled_writeOff: false,
      canResendSeconds_writeOff: 0,
      writeOffLoading: false,
      writeOffForm: {
        phoneNum: "",
        phoneText: "",
        verifyCode: "",
        verifyKey: "",
      },
      writeOffRules: {
        phoneNum: [
          { required: true, trigger: "blur", message: "请输入手机号" },
          {
            pattern: mobile_reg,
            trigger: "blur",
            message: "请输入正确的手机号码",
          },
        ],
        verifyCode: [
          { required: true, trigger: "blur", message: "请输入验证码" },
        ],
      },
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["name"]),
    stepModalTitle() {
      if (this.editPhoneStep === 1) {
        return "校验当前绑定手机号";
      } else {
        return "绑定新手机号";
      }
    },
    emailModalTitle() {
      if (this.currentEmailStep === 1) {
        return this.userInfo.email ? "校验当前绑定邮箱" : "校验并绑定新邮箱";
      } else {
        return "校验并绑定邮箱";
      }
    },
    emailModalStep() {
      let step;
      if (this.currentEmailStep === 1 && !!this.userInfo.email) {
        step = 1;
      } else if (
        (this.currentEmailStep === 1 && !this.userInfo.email) ||
        this.currentEmailStep === 2
      ) {
        step = 2;
      }
      return step;
    },
    vCodeBtnText() {
      return this.vCodeBtnDisabled
        ? this.canResendSeconds1 + "秒后重新获取"
        : "获取验证码";
    },
    vCodeBtnText2() {
      return this.vCodeBtnDisabled2
        ? this.canResendSeconds2 + "秒后重新获取"
        : "获取验证码";
    },
    vCodeBtnTextEmail1() {
      return this.vCodeBtnDisabledEmail1
        ? this.canResendEmailSeconds1 + "秒后重新获取"
        : "获取验证码";
    },
    vCodeBtnTextEmail2() {
      return this.vCodeBtnDisabledEmail2
        ? this.canResendEmailSeconds2 + "秒后重新获取"
        : "获取验证码";
    },
    vCodeBtnTextPwd() {
      return this.vCodeBtnDisabled_pwd
        ? this.canResendSeconds_pwd + "秒后重新获取"
        : "获取验证码";
    },
    vCodeBtnTextWriteOff() {
      return this.vCodeBtnDisabled_writeOff
        ? this.canResendSeconds_writeOff + "秒后重新获取"
        : "获取验证码";
    },
  },
  filters: {
    tuomin(value) {
      if (value && value.length === 11) {
        let reg = /(\d{3})\d*(\d{3})/;
        return value.replace(reg, "$1*****$2");
      }
      return " - ";
    },
  },
  mounted() {
    this.$store
      .dispatch("GetUserInfo")
      .then((data) => {
        this.userInfo = data;
      })
      .finally(() => {
        this.userInfoFetchDone = true;
      });
    apiGetUserUnit().then((res) => {
      // console.log('用户机构返回', res)
      let { data = [] } = res;
      let tableData = data.map((item) => {
        let { deptName, subject, joinDate } = item;
        let [date, time] = joinDate.split("T");
        time = time.substr(0, 8);
        return { deptName, subject, joinDate: date + " " + time };
      });
      this.tableData = tableData;
    });
    apiGetAuthConfig().then((res) => {
      Object.assign(this.$data, res.data);
    });
  },
  methods: {
    nicknameChange(v) {
      this.truenameForm.truename = v.replace(/(^\s*)|(\s*$)/g, "");
    },
    openPwdStep1Modal() {
      let reg = /(\d{3})\d*(\d{3})/;
      if (!!this.userInfo.phoneNumber) {
        this.editPwdForm.phoneNum = this.userInfo.phoneNumber;
        this.editPwdForm.phoneText = String(this.userInfo.phoneNumber).replace(
          reg,
          "$1*****$2"
        );
      }
      this.currentModal = "editPwd";
      this.editPwdShow = true;
    },

    openWriteOffModal() {
      //2022-08-10变更：以dialog的方式分布操作
      let reg = /(\d{3})\d*(\d{3})/;
      if (!!this.userInfo.phoneNumber) {
        this.writeOffForm.phoneNum = this.userInfo.phoneNumber;
        this.writeOffForm.phoneText = String(this.userInfo.phoneNumber).replace(
          reg,
          "$1*****$2"
        );
      }
      this.writeOffShow = true;
      this.writeOffStep = 1;
      this.currentModal = "writeOff";
    },
    changePhoneNum() {
      let reg = /(\d{3})\d*(\d{3})/;
      if (!!this.userInfo.phoneNumber) {
        this.step1Form.phoneNum = this.userInfo.phoneNumber;
        this.step1Form.phoneText = String(this.userInfo.phoneNumber).replace(
          reg,
          "$1*****$2"
        );
      }
      this.editPhoneStep = 1;
      this.stepShow = true;
      this.currentModal = "editPhone";
    },
    changeUserName() {
      this.truenameShow = true;
    },
    handleBindWx() {
      this.$message.warning("功能尚未开启");
    },
    changeEmail() {
      if (!!this.userInfo.email) {
        this.emailForm.email = this.userInfo.email;
      }
      this.currentEmailStep = 1;
      this.emailModalShow = true;
    },
    beforeWriteOffClose(close) {
      this.writeOffStep = 1;
      this.currentModal = "";
      (this.writeOffForm = {
        phoneNum: "",
        phoneText: "",
        verifyCode: "",
        verifyKey: "",
      }),
        close();
    },
    beforeStepClose(close) {
      let step1Form = {
          phoneNum: "",
          phoneText: "",
          verifyCode: "",
        },
        phoneStep2Form = {
          phoneNum: "",
          verifyCode: "",
        };
      this.step1Form = step1Form;
      this.phoneStep2Form = phoneStep2Form;
      this.currentModal = "";
      close();
    },
    beforeEditPwdClose(close) {
      this.currentModal = "";
      this.editPwdForm = {
        phoneNum: "",
        phoneText: "",
        verifyCode: "",
        verifyKey: "",
        password: "",
        confirmPassword: "",
      };
      close();
    },
    beforeTruenameClose(close) {
      this.truenameForm = { truename: "" };
      close();
    },
    beforeEmailClose(close) {
      this.emailForm = {
        email: "",
        code: "",
        uuid: "",
      };
      this.emailForm2 = {
        email: "",
        code: "",
        uuid: "",
      };
      close();
    },
    // 事件：获取验证码按钮
    openBioReg() {
      // 先校验手机号, 通过则打开滑块验证控件
      this.currentModal === "editPhone" &&
        this.$refs.step1Form.validateField("phoneNum", (error, field) => {
          if (!error.length) {
            this.isValidateBlock
              ? this.$refs.bioReg.show()
              : this.getVerifyCode();
          }
        });
      this.currentModal === "editPwd" &&
        this.$refs.editPwdForm.validateField("phoneNum", (error, field) => {
          if (!error.length) {
            this.isValidateBlock
              ? this.$refs.bioReg.show()
              : this.getVerifyCode();
          }
        });
      this.currentModal === "writeOff" &&
        this.$refs.writeOffForm.validateField("phoneNum", (error, field) => {
          if (!error.length) {
            this.isValidateBlock
              ? this.$refs.bioReg.show()
              : this.getVerifyCode();
          }
        });
    },
    // 事件：修改新手机获取验证码按钮
    openBioRegStep2() {
      // 先校验手机号, 通过则打开滑块验证控件
      this.$refs.phoneStep2Form.validateField("phoneNum", (error, field) => {
        if (!error.length) {
          this.isValidateBlock
            ? this.$refs.bioReg.show()
            : this.getVerifyCode();
        }
      });
    },
    // 事件：修改邮箱获取验证码按钮
    openBioRegEmail1() {
      // 先校验邮箱格式, 通过则打开滑块验证控件
      this.$refs.emailForm.validateField("email", (error, field) => {
        if (!error.length) {
          this.isValidateBlock
            ? this.$refs.bioReg.show()
            : this.getEmailVerifyCode();
        }
      });
    },
    openBioRegEmail2() {
      // 先校验邮箱格式, 通过则打开滑块验证控件
      this.$refs.emailForm2.validateField("email", (error, field) => {
        if (!error.length) {
          this.isValidateBlock
            ? this.$refs.bioReg.show()
            : this.getEmailVerifyCode();
        }
      });
    },
    // 滑块式生物识别, 通过则请求短信验证码
    bioRegPass(result) {
      this.bioVerification = result.captchaVerification;
      if (this.emailForm.email || this.emailForm2.email) {
        this.getEmailVerifyCode(result.captchaVerification);
        return;
      }
      this.getVerifyCode(result.captchaVerification);
    },
    // 请求短信验证码
    getVerifyCode(bioVerification) {
      if (this.isValidateBlock && !bioVerification) {
        this.$message.error("安全验证失败");
        return;
      }
      if (this.currentModal === "writeOff") {
        this.$refs.writeOffForm.validateField("phoneNum", (error, field) => {
          if (!error.length) {
            let params = {
              phoneNum: this.writeOffForm.phoneNum,
              type: 6, //6：注销
            };
            params = this.isValidateBlock
              ? { ...params, verification: bioVerification }
              : params;
            apiSendMsgCode(params).then((res) => {
              // 请求验证码成功则开启重发保护倒计时
              let { key, retrySendIntervalSeconds } = res.data;
              this.writeOffForm.verifyKey = key;
              this.startCountdown(retrySendIntervalSeconds);
            });
          }
        });
      }
      if (this.currentModal === "editPwd") {
        this.$refs.editPwdForm.validateField("phoneNum", (error, field) => {
          if (!error.length) {
            let params = {
              phoneNum: this.editPwdForm.phoneNum,
              type: 5, //5：修改密码
            };
            params = this.isValidateBlock
              ? { ...params, verification: bioVerification }
              : params;
            apiSendMsgCode(params).then((res) => {
              // 请求验证码成功则开启重发保护倒计时
              let { key, retrySendIntervalSeconds } = res.data;
              this.editPwdForm.verifyKey = key;
              this.startCountdown(retrySendIntervalSeconds);
            });
          }
        });
      }
      if (this.currentModal === "editPhone") {
        // 因为前置逻辑验证过这里可不校验手机，健壮性起见二次验证
        this.editPhoneStep === 1 &&
          this.$refs.step1Form.validateField("phoneNum", (error, field) => {
            if (!error.length) {
              let params = {
                phoneNum: this.step1Form.phoneNum,
                type: 4, //4：登录 TODO这里使用了hack方式来进行短信验证，最好接口进行调整
              };
              params = this.isValidateBlock
                ? { ...params, verification: bioVerification }
                : params;
              apiSendMsgCode(params).then((res) => {
                // 请求验证码成功则开启重发保护倒计时
                let { key, retrySendIntervalSeconds } = res.data;
                this.verifyKey = key;
                this.startCountdown(retrySendIntervalSeconds);
              });
            }
          });
        // 因为前置逻辑验证过这里可不校验手机，健壮性起见二次验证
        this.editPhoneStep === 2 &&
          this.$refs.phoneStep2Form.validateField(
            "phoneNum",
            (error, field) => {
              if (!error.length) {
                let params = {
                  phoneNum: this.phoneStep2Form.phoneNum,
                  type: 3, // 3：注册
                };
                params = this.isValidateBlock
                  ? { ...params, verification: bioVerification }
                  : params;
                apiSendMsgCode(params).then((res) => {
                  // 请求验证码成功则开启重发保护倒计时
                  let { key, retrySendIntervalSeconds } = res.data;
                  this.verifyKey2 = key;
                  this.startCountdown(retrySendIntervalSeconds);
                });
              }
            }
          );
      }
    },
    getEmailVerifyCode(bioVerification) {
      this.emailModalStep === 1 &&
        this.$refs.emailForm.validateField("email", (error, field) => {
          if (!error.length) {
            let id = uuidv4();
            let params = {
              email: this.emailForm.email,
              id,
            };
            params = this.isValidateBlock
              ? { ...params, verification: bioVerification }
              : { ...params };
            apiVerifyEmail(params).then((res) => {
              // 请求验证码成功则开启重发保护倒计时
              this.$message.success("验证码已发送到您邮箱，请注意查收");
              this.emailForm.uuid = id;
              this.startEmailCountdown(60);
            });
          }
        });
      this.emailModalStep === 2 &&
        this.$refs.emailForm2.validateField("email", (error, field) => {
          if (!error.length) {
            let id = uuidv4();
            let params = {
              email: this.emailForm2.email,
              id,
            };
            params = this.isValidateBlock
              ? { ...params, verification: bioVerification }
              : { ...params };
            apiVerifyEmail(params).then((res) => {
              // 请求验证码成功则开启重发保护倒计时
              console.log("请求邮箱验证码", res);
              this.$message.success("验证码已发送到您邮箱，请注意查收");
              this.emailForm2.uuid = id;
              this.startEmailCountdown(60);
            });
          }
        });
    },
    // 短信验证码重发保护
    startCountdown(seconds) {
      const _this = this;
      if (this.currentModal === "writeOff") {
        this.canResendSeconds_writeOff = seconds || 60;
        this.vCodeBtnDisabled_writeOff = true;
        this.timerWriteOff = setInterval(() => {
          if (_this.canResendSeconds_writeOff === 1) {
            _this.vCodeBtnDisabled_writeOff = false;
            clearInterval(_this.timerWriteOff);
            _this.timerWriteOff = null;
          }
          _this.canResendSeconds_writeOff--;
        }, 1000);
        return;
      }
      if (this.currentModal === "editPwd") {
        this.canResendSeconds_pwd = seconds || 60;
        this.vCodeBtnDisabled_pwd = true;
        this.timerPwd = setInterval(() => {
          if (_this.canResendSeconds_pwd === 1) {
            _this.vCodeBtnDisabled_pwd = false;
            clearInterval(_this.timerPwd);
            _this.timerPwd = null;
          }
          _this.canResendSeconds_pwd--;
        }, 1000);
        return;
      }
      if (this.currentModal === "editPhone") {
        if (this.editPhoneStep === 1) {
          this.canResendSeconds1 = seconds || 60;
          this.vCodeBtnDisabled = true;
          this.timer = setInterval(() => {
            if (_this.canResendSeconds1 === 1) {
              _this.vCodeBtnDisabled = false;
              clearInterval(_this.timer);
              _this.timer = null;
            }
            _this.canResendSeconds1--;
          }, 1000);
        } else {
          this.canResendSeconds2 = seconds || 60;
          this.vCodeBtnDisabled2 = true;
          this.timer2 = setInterval(() => {
            if (_this.canResendSeconds2 === 1) {
              _this.vCodeBtnDisabled2 = false;
              clearInterval(_this.timer2);
              _this.timer2 = null;
            }
            _this.canResendSeconds2--;
          }, 1000);
        }
      }
    },
    // 邮箱验证码重发保护
    startEmailCountdown(seconds) {
      const _this = this;
      if (this.emailModalStep === 1) {
        this.canResendEmailSeconds1 = seconds || 60;
        this.vCodeBtnDisabledEmail1 = true;
        this.emailTimer = setInterval(() => {
          if (_this.canResendEmailSeconds1 === 1) {
            _this.vCodeBtnDisabledEmail1 = false;
            clearInterval(_this.emailTimer);
            _this.emailTimer = null;
          }
          _this.canResendEmailSeconds1--;
        }, 1000);
      } else if (this.emailModalStep === 2) {
        this.canResendEmailSeconds2 = seconds || 60;
        this.vCodeBtnDisabledEmail2 = true;
        this.emailTimer2 = setInterval(() => {
          if (_this.canResendEmailSeconds2 === 1) {
            _this.vCodeBtnDisabledEmail2 = false;
            clearInterval(_this.emailTimer2);
            _this.emailTimer2 = null;
          }
          _this.canResendEmailSeconds2--;
        }, 1000);
      }
    },
    goNextStep() {
      // 验证表单成功则进行密码重置或者新手机绑定
      this.$refs.step1Form.validate().then((_) => {
        let { phoneNum, verifyCode: code } = this.step1Form;
        let params = {
          phoneNum,
          code,
          key: this.verifyKey,
          customType: "pc",
        };
        apiLogin("sms", params).then((res) => {
          let { access_token } = res.data;
          if (!access_token) {
            this.$message.error("手机校验失败");
            return;
          }
          setToken(access_token);
          this.$store.commit("SET_TOKEN", access_token);
          this.editPhoneStep = 2;
        });
      });
    },
    goEmailNext() {
      this.$refs.emailForm.validate().then((_) => {
        let { email, code, uuid } = this.emailForm;

        apiCheckVerifyCode({ code, id: uuid })
          .then((res) => {
            console.log("校验验证码：", res);
            this.currentEmailStep = 2;
          })
          .catch((err) => {
            this.$message.error("验证码校验失败");
          });
      });
    },
    handleWriteOff() {
      this.$refs.writeOffForm.validate().then(() => {
        let {
          phoneNum: phoneNumber,
          verifyCode: smsCode,
          verifyKey: smsCodeKey,
        } = this.writeOffForm;
        let data = {
          smsCode,
          smsCodeKey,
          phoneNumber,
        };
        apiCalcleUser(data).then((res) => {
          if (res.data) {
            this.$message.error("注销失败，请联系管理员");
            return;
          }
          this.writeOffShow = false;
          this.$store.dispatch("FedLogOut").then(() => {
            this.$router.push("/index");
          });
        });
      });
    },
    handleSetNewPwd() {
      this.$refs.editPwdForm.validate().then(() => {
        let {
          verifyCode: code,
          verifyKey: key,
          phoneNum: phoneNumber,
          password,
        } = this.editPwdForm;
        let data = {
          code,
          key,
          phoneNumber,
          password: this.isPwdEncrypt ? encrypt(password) : password,
        };
        apiUpdatePwd(data)
          .then((res) => {
            console.log(res);
            this.$message.success("密码修改成功,请重新登录");
            setTimeout(() => {
              this.$store.dispatch("LogOut").then(() => {
                this.$router.push("/login");
              });
            }, 800);
          })
          .finally(() => {
            this.editPwdShow = false;
            this.editPwdForm = {
              phoneNum: "",
              phoneText: "",
              verifyCode: "",
              verifyKey: "",
              password: "",
              confirmPassword: "",
            };
          });
      });
    },
    handleSetNewPhone() {
      this.$refs.phoneStep2Form.validate().then(() => {
        let { phoneNum: phoneNumber, verifyCode: smsCode } =
          this.phoneStep2Form;
        let { verifyKey2: smsCodeKey } = this;
        let data = {
          smsCode,
          smsCodeKey,
          phoneNumber,
        };
        apiUpdatePhone(data)
          .then((res) => {
            console.log(res);
            this.userInfo.phoneNumber = phoneNumber;
            this.$message.success("手机号绑定成功");
            // setTimeout(() => {
            //   this.$store.dispatch('FedLogOut').then(() => {
            //     this.$router.push('/login')
            //   })
            // }, 800)
          })
          .finally(() => {
            this.step1Form = {
              phoneNum: "",
              verifyCode: "",
            };
            this.phoneStep2Form = {
              phoneNum: "",
              verifyCode: "",
            };
            this.stepShow = false;
          });
      });
    },
    handleSetTruename() {
      this.$refs.truenameForm.validate().then(() => {
        let { truename } = this.truenameForm;
        apiUpdateTrueName({ truename })
          .then(() => {
            this.userInfo.truename = truename;
            this.$store.commit("SET_NAME", truename);
            this.$message.success("昵称修改成功");
          })
          .finally(() => {
            this.truenameForm = { truename: "" };
            this.truenameShow = false;
          });
      });
    },
    handleSetEmail() {
      this.$refs.emailForm2.validate().then(() => {
        let { email, code, uuid } = this.emailForm2;
        apiCheckVerifyCode({ code, id: uuid })
          .then((res) => {
            console.log("校验验证码：", res);
            if (res.data && res.data.pass !== true) {
              this.$message.error("邮箱或验证码错误");
              return;
            }
            apiUpdateEmail({ email })
              .then(() => {
                this.userInfo.email = email;
                this.$message.success("邮箱修改成功");
              })
              .finally(() => {
                this.emailForm2 = { email: "", code: "", uuid: "" };
                this.emailModalShow = false;
              });
          })
          .catch((err) => {
            this.$message.error("验证码校验失败");
          });
      });
    },
    equalToPassword(rule, value, callback) {
      if (this.editPwdForm.password !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    },
    validPassword(rule, value, callback) {
      let reg = /(?=.*[a-z_])(?=.*\d)(?=.*[^a-z0-9_])[\S]{8,20}/i;
      if (!reg.test(value)) {
        callback(new Error("密码必须包含字母数字和特殊符号，8-20个字符"));
      } else {
        callback();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.unit-table-box ::v-deep {
  .el-table__header {
    .el-table__cell {
      // padding-left: 80px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      text-align: center;
    }
  }
  .el-table__body {
    .el-table__cell {
      // padding-left: 50px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      text-align: center;
    }
  }
}
.ou-modal ::v-deep {
  .el-dialog {
    margin-top: calc((100vh - 300px) / 2) !important;
  }
  .el-dialog__body {
    padding: 30px 20px 10px;
  }
}

.form-wrap ::v-deep {
  .form-item {
    margin-bottom: 2.23vh;
    &.hidden-item {
      visibility: hidden;
      height: 1px;
      margin: 0;
    }
    &.vcode-item {
      .el-form-item__content {
        display: flex;
      }
    }

    .el-input__inner {
      height: 48px;
      line-height: 48px;
    }

    .vcode-btn {
      width: 88px;
      height: 48px;
      margin-left: 12px;
      background: #e4f0ff;
      border-radius: 6px;
      color: #2e9adb;
      padding: 10px 4px;
      transition: width 200ms ease-in-out;
      &.biger {
        width: 120px;
      }
    }
  }
}

.ou-btn {
  background-color: #2e9adb;
  border-radius: 6px;
  padding: 12px 26px;
  &-block {
    width: 100%;
    & + .ou-btn-block {
      margin: 0;
    }
  }
  &-mono {
    min-width: 100px;
  }
}

.write-off-tip {
  text-align: center;
  padding-bottom: 10px;
  line-height: 1.8;
}
.tip-row {
  padding-left: 4px;
  padding-bottom: 12px;
}
</style>
